import { render, staticRenderFns } from "./edit-user-return.vue?vue&type=template&id=4573ee12&scoped=true"
import script from "./edit-user-return.vue?vue&type=script&lang=ts"
export * from "./edit-user-return.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573ee12",
  null
  
)

export default component.exports